/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
export const strings = {
    sendEmailLinkSubtitle: 'Send email',
    startChatLinkSubtitle: 'Start chat',
    showMoreSectionButton: 'Show more',
    endOfCard: 'End of the card'
};
//# sourceMappingURL=strings.js.map